import { currencyFormatter } from 'helpers/formatHelper';
import {
    ETP_FIELD,
    HOURS_FIELD,
    PERMANENT,
    SALARY_RAW_CHARGED_FIELD,
} from 'routes/HumanResourcesModule/business/definitions';
import {
    JobPermanent,
    SalaryMassLine,
} from 'routes/HumanResourcesModule/business/types';
import {
    formatETP,
    formatHours,
} from 'routes/HumanResourcesModule/PayState/helpers/formatHelpers';
import { DataPointT } from '../../components/PayStateBanner';
import {
    TableSalaryMassIndicatorsT,
    TableSalaryMassIndicatorT,
} from '../../helpers/hooks/payStateIndicators';

export function isAllUnmapped(salaryMass: SalaryMassLine[]): boolean {
    return salaryMass.every(
        (item) => item[PERMANENT] === JobPermanent.Unmapped,
    );
}

const formatter = (permanent: boolean) => (permanent ? formatETP : formatHours);
const valueSelector = (
    ind: TableSalaryMassIndicatorT,
    permanent: boolean,
): number => (permanent ? ind[ETP_FIELD] : ind[HOURS_FIELD]) || 0;

/** Return the indicators in the format used by the banner to display them.
 * @param indicators - The raw indicators from the hook/query.
 * @param permanent - If it is for permanent agent or not.
 * @returns Two DataPointT compatible with the banner.
 */
export const formatSalaryMassTableIndicatorsForBanner = (
    indicators: TableSalaryMassIndicatorsT | undefined,
    permanent: boolean,
): DataPointT[] => {
    if (indicators === undefined) return [];
    const sel = (v: TableSalaryMassIndicatorT) => valueSelector(v, permanent);
    const fmt = (v: number) => formatter(permanent)(v);
    const first: DataPointT = {
        current: sel(indicators.currentExercice),
        deltaFormatted: fmt(
            sel(indicators.currentExercice) -
                (indicators.previousExercice
                    ? sel(indicators.previousExercice)
                    : 0),
        ),
        ...(indicators.previousExercice
            ? { previous: sel(indicators.previousExercice) }
            : {}),
    };

    const second: DataPointT = {
        current: indicators.currentExercice[SALARY_RAW_CHARGED_FIELD],
        deltaFormatted: currencyFormatter(
            indicators.currentExercice[SALARY_RAW_CHARGED_FIELD] -
                (indicators.previousExercice
                    ? indicators.previousExercice[SALARY_RAW_CHARGED_FIELD]
                    : 0),
        ),
        ...(indicators.previousExercice
            ? {
                  previous:
                      indicators.previousExercice[SALARY_RAW_CHARGED_FIELD],
              }
            : {}),
    };

    return [first, second];
};
